export default __webpack_public_path__ + "static/media/rarity-btn-legendary.5fd1bf33.svg";